// extracted by mini-css-extract-plugin
export default {"top":"ModuleSpacing-module--top--mR1pL","left":"ModuleSpacing-module--left--IShO-","right":"ModuleSpacing-module--right--obC0-","bottom":"ModuleSpacing-module--bottom--qxwT1"};